const PRODUCT_USER = '61ddd8622e44ed6c32f3c3aa';

const hideAuthor = ({ authorId }) => (
  authorId === PRODUCT_USER
);

export default hideAuthor;
